import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

/* --------------------------------- VPA Bulk Upload ------------------------------ */

export interface VpaDetails {
  vpa: string;
  vpa_id: string;
  status: string | null;
  provider_name: string;
  qr_image: string | null;
  tenant_id: string;
  mapping_status: string | null;
  reason: string | null;
}

interface VpaData {
  user: string | null;
  vpa: [VpaDetails] | null;
}

export const uploadVpaBulk = createAsyncThunk("vpa/bulkUpload", async ({ csvFile, tenantId }: { csvFile: File; tenantId: string }, { rejectWithValue }) => {
  
  const formData = new FormData();
  if (csvFile) {
    formData.append("file", csvFile);
  }

  if (tenantId) {
    formData.append("tenantId", tenantId);
  }

  const token = localStorage.getItem("accessToken");

  try {
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/uploadVpa/sheet`,
      timeout: 10000,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
      method: "POST",
    });

    return {
      user: response.data?.data?.user,
      vpa: response.data?.data?.result as VpaDetails[],
    } as VpaData;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data?.message ? error.response.data.message : "Failed to Upload VPA");
  }
});

/* --------------------------------- Main State ------------------------------ */

interface VpaState {
  vpaBulk: null | VpaData;
  vpaError: any | null;
  vpaLoading: boolean;
}

const initialState: VpaState = {
  vpaBulk: null,
  vpaError: null,
  vpaLoading: false,
};



const vpaSlice = createSlice({
  name: "recon",
  initialState,
  reducers: {
    clearBulkVpaUpload(state) {
      state.vpaBulk = null;
      state.vpaLoading = false;
      state.vpaError = null;
    },
  },
  extraReducers: (builder) => {
    builder
  
      // Vpa Bulk Upload
      .addCase(uploadVpaBulk.pending, (state) => {
        state.vpaLoading = true;
        state.vpaError = null;
      })
      .addCase(uploadVpaBulk.fulfilled, (state, action: PayloadAction<VpaData>) => {
        state.vpaLoading = false;
        state.vpaBulk = action.payload;
      })
      .addCase(uploadVpaBulk.rejected, (state, action) => {
        state.vpaLoading = false;
        state.vpaError = action.payload || "Failed to upload VPAs";
      });
  },
});

export const { clearBulkVpaUpload } = vpaSlice.actions;

export default vpaSlice.reducer;
